import intl from 'react-intl-universal';
// import { Form } from 'antd';
import { ProFormList, ProFormText } from '@ant-design/pro-components';
import { useState } from 'react';
import { Row, Col } from 'antd';
import { default as Button } from '@/components/CssBtn';

import { DeleteOutlined } from '@ant-design/icons';
import SelectOrders from './components/SelectOrders';
import SelectGoods from './components/SelectGoods';

import style from '../index.less';

type action = {
    /**
     * @name 获取当前行的数据
     * @example getCurrentRowData -> {id:"xxx",name:'123',age:18}
     */
    getCurrentRowData: () => any;
    /**
     * @name 设置当前行的数据
     * @example {id:"123",name:'123'} -> setCurrentRowData({name:'xxx'}) -> {id:"123",name:'123'}
     * @example {id:"123",name:'123'} -> setCurrentRowData({name:undefined}) -> {id:"123"}
     */
    setCurrentRowData: (data: any) => void;
};

interface Props {
    value: any[];
    onChange: (value: any[]) => void;
    readonly?: boolean;
    required?: boolean;
    labelCol?: number;
    id: string;
}

const MAXLENGTH = 100;

const Order: React.FC<Props> = ({
    readonly = false,
    required = true,
    id,
    value = [{}],
    labelCol = 6,
    onChange,
    ...OhterProps
}) => {
    const [selectOrders, setSelectOrders] = useState<string[]>([]);
    const [showSelectOrder, setShowSelectOrder] = useState(false);
    const [showSelectGoods, setShowSelectGoods] = useState(false);

    const [currentOrder, setCurrentOrder] = useState<string>();
    const [currentGoods, setCurrentGoods] = useState([]);
    const [currentIndex, setCurrenIndex] = useState<number>();

    const onShowOrder = (e) => {
        e.target?.blur();
        setSelectOrders(
            value.map((item) => item.ddh)?.filter((item) => !!item) || [],
        );
        setShowSelectOrder(true);
    };
    const onShowGood = (action: action, index: number) => {
        const rowData = action.getCurrentRowData();
        setCurrentOrder(rowData?.ddh);
        setCurrentGoods(rowData?.xzsp || []);
        setCurrenIndex(index);

        setShowSelectGoods(true);
    };

    const onSelectOrder = (orders: string[]) => {
        if (orders?.length) {
            onChange?.(
                orders.map((i) => {
                    const item = value.find((o) => o.ddh === i);
                    return {
                        ddh: i,
                        xzsp: item?.xzsp || [],
                    };
                }),
            );
        } else {
            onChange?.([{}]);
        }
    };

    const onSelectGoods = (goods) => {
        value.splice(currentIndex, 1, {
            ddh: currentOrder,
            xzsp: goods,
        });

        onChange(value);
    };

    const onDelGoodItem = (
        index: number,
        action: action,
        goodIndex: number,
    ) => {
        const item = action.getCurrentRowData();
        item.xzsp?.splice(goodIndex, 1);
        value.splice(index, 1, {
            ...item,
        });

        onChange(value);
    };

    return (
        <div>
            <ProFormList
                readonly={readonly}
                // value={value}
                className="worder-order-form-list"
                name={id}
                initialValue={value}
                alwaysShowItemLabel={true}
                min={1}
                max={MAXLENGTH}
                colProps={{ span: 24 }}
                copyIconProps={false}
                {...OhterProps}
                // deleteIconProps={readonly ? false : true}
                // creatorButtonProps={false}
            >
                {(meta, index, action) => (
                    <div>
                        <ProFormText
                            // width="md"
                            name="ddh"
                            label={intl.get('订单号')}
                            labelCol={{ span: labelCol }}
                            rules={[
                                {
                                    required,
                                    message: intl.get('请输入订单号'),
                                },
                            ]}
                            validateTrigger="onBlur"
                            fieldProps={{
                                onClick: (e) => {
                                    onShowOrder(e);
                                },
                            }}
                        />

                        {!!action.getCurrentRowData()?.xzsp?.length && (
                            <Row>
                                <Col
                                    offset={labelCol}
                                    className={style.goods_container}
                                    span={24 - labelCol}
                                >
                                    <div className={style.label}>
                                        {intl.get('商品列表：')}
                                    </div>
                                    {action
                                        .getCurrentRowData()
                                        ?.xzsp?.map((item, childIndex) => (
                                            <div
                                                key={childIndex}
                                                className={style.goods_item}
                                            >
                                                <div>
                                                    <div
                                                        className={
                                                            style.good_title
                                                        }
                                                    >
                                                        {item.name}
                                                    </div>
                                                    <div>SKU:{item.sku}</div>
                                                </div>
                                                {!readonly && (
                                                    <DeleteOutlined
                                                        className={
                                                            style.good_del_btn
                                                        }
                                                        size={16}
                                                        onClick={() => {
                                                            onDelGoodItem(
                                                                index,
                                                                action,
                                                                childIndex,
                                                            );
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        ))}
                                </Col>
                            </Row>
                        )}

                        {!readonly && (
                            <Row>
                                <Col
                                    span={24}
                                    offset={labelCol}
                                >
                                    <Button
                                        type="link"
                                        disabled={
                                            !action.getCurrentRowData()?.ddh
                                        }
                                        onClick={() => {
                                            onShowGood(action, index);
                                        }}
                                    >
                                        {intl.get('绑定商品')}
                                    </Button>
                                </Col>
                            </Row>
                        )}
                    </div>
                )}
            </ProFormList>

            <SelectOrders
                selectOrders={selectOrders}
                open={showSelectOrder}
                maxlength={MAXLENGTH}
                onClose={setShowSelectOrder}
                onConfirm={onSelectOrder}
            ></SelectOrders>
            {showSelectGoods && (
                <SelectGoods
                    open={showSelectGoods}
                    business_order_no={currentOrder}
                    goods={currentGoods}
                    onClose={setShowSelectGoods}
                    onConfirm={onSelectGoods}
                ></SelectGoods>
            )}
        </div>
        // </Form.Item>
    );
};

export default Order;
